function showMoreItems() {
    const items = document.querySelectorAll('#other_rates_panel .item');
    items.forEach(item => item.classList.remove('hidden'));
    $('#showMoreBtn').css('display', 'none');
    $('#hideBtn').css('display', 'inline');

    // Change arrow
    const toggles = document.querySelectorAll('#other_rates_panel .btn-offers-toggle');
    toggles.forEach(btn => {
        btn.classList.add('arrow-up');
        btn.classList.remove('arrow-down');
    });
}

function hideItems() {
    
    const numberOfOtherOffers = $('#landingpageInitialNumberOfOtherOffers').val();
 
    const items = document.querySelectorAll('#other_rates_panel .item');
    items.forEach((item, index) => {
        if (index >= numberOfOtherOffers) {
            item.classList.add('hidden');
        }
    });
    $('#showMoreBtn').css('display', 'inline');
    $('#hideBtn').css('display', 'none');

    // Change arrow
    const toggles = document.querySelectorAll('#other_rates_panel .btn-offers-toggle');
    toggles.forEach(btn => {
        btn.classList.add('arrow-down');
        btn.classList.remove('arrow-up');
    });
}